@if (viewState$ | async; as viewState) {
    <bs-reward-tokens-onboarding [viewState]="viewState" (dismiss)="hideOnboarding()" />
}
